module.exports = __webpack_public_path__ + "static/og-02272163887a47e7a7f9e424d8f3d380.jpg";